// extracted by mini-css-extract-plugin
export default {"pageLayout":"Interests-module__pageLayout___Ye1tk"};